import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { ROLES } from '../lib/permissions';

const TABS = [
  {
    id: 'hoy',
    path: '/',
    label: 'Hoy',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" />
        <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
      </svg>
    ),
  },
  {
    id: 'sesiones',
    path: '/sesiones',
    label: 'Sesiones',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M3 9h18M9 3v18" />
        <path d="M13 13h4M13 17h4" />
      </svg>
    ),
  },
  {
    id: 'buscar',
    path: '/buscar',
    label: 'Animales',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
      </svg>
    ),
  },
  {
    id: 'datos',
    path: '/datos',
    label: 'Datos',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M18 20V10M12 20V4M6 20v-6" />
      </svg>
    ),
  },
  {
    id: 'perfil',
    path: '/perfil',
    label: 'Perfil',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
];

export function TabBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const role = useAuthStore((s) => s.role);
  const config = ROLES[role];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-[var(--bg-primary)] border-t border-[var(--border-default)] flex items-stretch px-1 pb-[env(safe-area-inset-bottom,8px)] z-[100] lg:hidden">
      {TABS.map((tab) => {
        const active = isActive(tab.path);
        const label = tab.id === 'hoy' ? config.hoyLabel : tab.label;
        return (
          <button
            key={tab.id}
            onClick={() => navigate(tab.path)}
            className={`flex-1 flex flex-col items-center justify-center py-2 px-1 cursor-pointer border-none bg-transparent gap-[3px] min-h-[56px] relative transition-colors duration-150 ${active ? 'text-[var(--status-info)]' : 'text-[var(--text-tertiary)]'}`}
          >
            {tab.icon}
            <span className="text-[var(--fs-xs)] font-semibold tracking-wide">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
